import { FormHelperText, Grid, TextField } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import { Dispatch, SetStateAction } from 'react'
import Dropzone from 'react-dropzone-uploader'
import { useTranslation } from 'react-i18next'
import 'react-dropzone-uploader/dist/styles.css'
import { RemoveContent } from '../../../../../shared/components/inputs/Dropzone'
import { IOffer } from '../../../models/offers'
import { useOffersModalGeneralTab } from '../../hooks/useOffersModalGeneralTab'

interface OffersModalGeneralTabProps {
  offerState: IOffer
  setOfferState: Dispatch<SetStateAction<IOffer>>
  errorForm: any
  msgForm: any
}

const OffersModalGeneralTab = ({ offerState, setOfferState, errorForm, msgForm }: OffersModalGeneralTabProps) => {
  const { t } = useTranslation(['global'])

  const {
    roles,
    countries,
    languages,
    types,
    status,
    visibility,
    handleAutoCompleteChange,
    handleNumberChange,
    getUploadParams,
    removeFileDropzone
  } = useOffersModalGeneralTab(offerState, setOfferState)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          id="combo-box-roles"
          value={offerState.role}
          onChange={handleAutoCompleteChange('role')}
          options={roles.filter((role: any) => role.code > 3)}
          getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
          renderInput={params => (
            <TextField
              required
              {...params}
              label={t('roles')}
              variant="filled"
              error={errorForm.role}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
        <FormHelperText error={errorForm.role}>{msgForm.role}</FormHelperText>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          id="combo-box-country"
          value={offerState.country}
          onChange={handleAutoCompleteChange('country')}
          options={countries}
          getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
          renderInput={params => (
            <TextField
              required
              {...params}
              label={t('country')}
              variant="filled"
              error={errorForm.countries}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
        <FormHelperText error={errorForm.countries}>{msgForm.countries}</FormHelperText>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          id="combo-box-language"
          value={offerState.language}
          onChange={handleAutoCompleteChange('language')}
          options={languages}
          getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
          renderInput={params => (
            <TextField
              required
              {...params}
              label={t('language')}
              variant="filled"
              error={errorForm.languages}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
        <FormHelperText error={errorForm.languages}>{msgForm.languages}</FormHelperText>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          id="combo-box-status"
          disableClearable
          value={status.find((stt: any) => stt.id === offerState.status)}
          onChange={handleNumberChange('status')}
          options={status}
          getOptionLabel={(option: any) => option.name}
          renderInput={params => <TextField {...params} label={t('status')} variant="filled" InputLabelProps={{ shrink: true }} />}
        />
        <FormHelperText error={errorForm.status}>{msgForm.status}</FormHelperText>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          id="combo-box-visibility"
          disableClearable
          value={visibility.find((vsb: any) => vsb.id === offerState.visibility)}
          onChange={handleNumberChange('visibility')}
          options={visibility}
          getOptionLabel={(option: any) => option.name}
          renderInput={params => <TextField {...params} label={t('visibility')} variant="filled" InputLabelProps={{ shrink: true }} />}
        />
        <FormHelperText error={errorForm.visibility}>{msgForm.visibility}</FormHelperText>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Autocomplete
          id="combo-box-types"
          disableClearable
          value={types.find((type: any) => type.id === offerState.type)}
          onChange={handleNumberChange('type')}
          options={types}
          getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
          renderInput={params => <TextField {...params} label={t('type')} variant="filled" InputLabelProps={{ shrink: true }} />}
        />
        <FormHelperText error={errorForm.type}>{msgForm.type}</FormHelperText>
      </Grid>

      <Grid item xs={12}>
        {offerState.id !== null && (
          <RemoveContent
            files={offerState.filesNames.filter(file => file.type === 0).map(file => `${import.meta.env.VITE_AWS_URL}/offers/${file.name}`)}
            onHandleClick={removeFileDropzone(0)}
          />
        )}
        <Dropzone
          getUploadParams={getUploadParams(0)}
          classNames={{ dropzone: 'dzu-dropzone-custom', inputLabel: 'dzu-inputlabel-custom' }}
          inputContent={`${t('cover-image')}*`}
          maxFiles={offerState.id != null ? 1 : 20}
        />
        <FormHelperText error={errorForm.filesNames}>{msgForm.filesNames}</FormHelperText>
      </Grid>
    </Grid>
  )
}

export default OffersModalGeneralTab
